import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from '@components/toolbar';
import { ButtonModule } from '@components/button';
import { LoadingModule } from '@components/loading';
import { CsIconModule } from '@components/icon';
import { PopUpModule } from '@components/pop-up';
import { RouterModule } from '@angular/router';
import { authenticationGuard } from '../guards/authentication.guard';
import { onboardingGuard } from '../guards/onboarding.guard';
import { IsotretinoinConsentForm } from './isotretinoin-consent-form/isotretinoin-consent-form.component';
import { SafetyCheckQuestionComponent } from './safety-check-question/safety-check-question.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([{
        path: 'isotretinoin-consent-form', canActivate: [authenticationGuard, onboardingGuard], component: IsotretinoinConsentForm,
    }, {
        path: 'safety-check-question', canActivate: [authenticationGuard, onboardingGuard], component: SafetyCheckQuestionComponent,
    }]),
    SafetyCheckQuestionComponent,
    ToolbarModule,
    ButtonModule,
    LoadingModule,
    CsIconModule,
    PopUpModule,
  ],
  declarations: [IsotretinoinConsentForm],
})
export class ConsentFormModule { }
